import React from 'react';

/** Profile illustration: a person, a shield, and a small crown. */
export function AccountArt() {
  return (
    <svg className="ac-art" viewBox="0 0 280 220" aria-hidden="true">
      <rect className="ac-art__sky" width="280" height="220" rx="24" />
      <circle className="ac-art__sun" cx="232" cy="36" r="14" />
      <path className="ac-art__hill" d="M0 140c40-24 70 10 112-6 32-12 52 14 90-2 22-10 40 6 78-8v96H0z" />
      <path className="ac-art__hill2" d="M0 174c48-16 72 12 120-2 36-10 54 12 160-10v58H0z" />
      <circle className="ac-art__head" cx="118" cy="86" r="22" />
      <path className="ac-art__body" d="M74 168c8-32 28-46 44-46s36 14 44 46" />
      <path className="ac-art__shield" d="M196 78c-16 7-22 14-22 26 0 18 12 30 22 36 10-6 22-18 22-36 0-12-6-19-22-26z" />
      <path d="M186 104l7 7 13-14" fill="none" stroke="#fff" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
      <path className="ac-art__crown" d="M168 58l8 10 10-14 10 14 8-10v16h-36z" />
    </svg>
  );
}

export function CoinsArt() {
  return (
    <svg className="ac-coins__svg" viewBox="0 0 88 88" aria-hidden="true">
      <circle className="ac-coin__back" cx="40" cy="48" r="22" />
      <circle className="ac-coin__front" cx="52" cy="38" r="24" />
      <path className="ac-coin__mark" d="M52 28v20M44 34h10a6 6 0 0 1 0 12h-8" fill="none" strokeWidth="3" strokeLinecap="round" />
    </svg>
  );
}

/** Placeholder for Premium before a plan is active, and inside the Go Premium dialog. */
export function PremiumArt() {
  return (
    <svg className="ac-prem-art" viewBox="0 0 220 140" aria-hidden="true">
      <rect className="ac-prem-art__sky" width="220" height="140" rx="18" />
      <circle className="ac-prem-art__sun" cx="176" cy="28" r="10" />
      <path className="ac-prem-art__hill" d="M0 96c36-20 58 8 92-4 28-10 42 12 78-2 16-8 30 4 50-6v56H0z" />
      <path className="ac-prem-art__crown" d="M78 78l16 18 16-26 16 26 16-18v28H78z" />
      <circle className="ac-prem-art__gem" cx="110" cy="58" r="6" />
    </svg>
  );
}
